import { Entity } from "@jobilla/entity";

export class InvoiceStatusHistory extends Entity {
  status!: string;
  userId!: number | null;
  createdAt!: string;
}
